import z from "zod";

import { zSchema } from "../../../../entity";

import { zOutSchema } from "./common";

const zIn = z.object({
  orderNumber: zSchema.shape.orderNumber.unwrap(),
});
type In = z.infer<typeof zIn>;

const zOut = z.array(zOutSchema);
type Out = z.infer<typeof zOut>;

export { zIn, zOut };
export type { In, Out };
